/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_SavedInputs */

const en_settings_profile_saved = /** @type {(inputs: Settings_Profile_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settings saved`)
};

const zh_settings_profile_saved = /** @type {(inputs: Settings_Profile_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`设置已保存`)
};

/**
* | output |
* | --- |
* | "Settings saved" |
*
* @param {Settings_Profile_SavedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_profile_saved = /** @type {((inputs?: Settings_Profile_SavedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_SavedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_profile_saved(inputs)
	return zh_settings_profile_saved(inputs)
});
export { settings_profile_saved as "settings.profile.saved" }